export enum PostHogEventEnum {

  LOGIN_INICIADO = 'login_iniciado',
  LOGIN_SUCESSO = 'login_sucesso',
  LOGIN_FALHOU = 'login_falhou',
  MFA_SOLICITADO = 'mfa_solicitado',
  MFA_VALIDADO = 'mfa_validado',
  CONTA_SELECIONADA = 'conta_selecionada',
  LOGOUT_REALIZADO = 'logout_realizado',

  MENU_CLICADO = 'menu_clicado',

  PREVISAO_VISITA_CRIADA = 'previsao_visita_criada',
  ENTRADA_REGISTRADA = 'entrada_registrada',
  SAIDA_REGISTRADA = 'saida_registrada',
  QRCODE_GERADO = 'qrcode_gerado',
  CHAVE_VIRTUAL_GERADA = 'chave_virtual_gerada',

  PESSOA_CRIADA = 'pessoa_criada',

  CAMERA_VISUALIZADA = 'camera_visualizada',
  LOCKER_ACIONADO = 'locker_acionado',

  FACIAL_CAMERA_ABERTA = 'facial_camera_aberta',
  FACIAL_CAMERA_FALHOU = 'facial_camera_falhou',
  FACIAL_MODELO_CARREGADO = 'facial_modelo_carregado',
  FACIAL_MODELO_FALHOU = 'facial_modelo_falhou',
  FACIAL_DETECCAO_FALHOU = 'facial_deteccao_falhou',
  FACIAL_ROSTO_DETECTADO = 'facial_rosto_detectado',
  FACIAL_CAPTURA_LIBERADA = 'facial_captura_liberada',
  FACIAL_FOTO_CAPTURADA = 'facial_foto_capturada',
  FACIAL_FOTO_CONFIRMADA = 'facial_foto_confirmada',
  FACIAL_ABANDONADO = 'facial_abandonado',
  FACIAL_ESPERA_PROLONGADA = 'facial_espera_prolongada',
  FACIAL_LOOP_TRAVADO = 'facial_loop_travado',
  FACIAL_INFERENCIA_DESCARTADA = 'facial_inferencia_descartada',
  FACIAL_CADASTRADA_FORA_PADRAO = 'facial_cadastrada_fora_padrao',

  API_ERRO = 'api_erro'
}
